(() => {
  if (customElements.get('oilogic-footer-credits')) return;

// <oilogic-footer-credits> — toggles the hidden "Site Credits" marquee panel.
class OilogicFooterCredits extends HTMLElement {
  #ctrl = new AbortController();

  connectedCallback() {
    this.link = this.querySelector('[role="button"]');
    this.panel = this.querySelector('.footer__credits-marquee');
    if (!this.link || !this.panel) return;

    this.link.addEventListener('click', this.handleClick, { signal: this.#ctrl.signal });
  }

  disconnectedCallback() {
    this.#ctrl.abort();
  }

  handleClick = (event) => {
    event.preventDefault();
    const expanded = this.link.getAttribute('aria-expanded') === 'true';
    this.link.setAttribute('aria-expanded', String(!expanded));
    this.panel.classList.toggle('is-visible', !expanded);
  };
}

customElements.define('oilogic-footer-credits', OilogicFooterCredits);
})();
